// extracted by mini-css-extract-plugin
export default {"container":"styles_container__BXm4W","description_textarea":"styles_description_textarea__4dzsu","error_border_color":"styles_error_border_color__FoeUF"};